export const nmDisplaySetSelector = {
    seriesMatchingRules: [
        {
            attribute: 'Modality',
            constraint: {
                inclusion: ['PT', 'NM']
            },
            required: true
        },
        {
            attribute: 'numImageFrames',
            constraint: {
                greaterThan: 0 
            },
            required: true
        }
    ]
};